<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useQuery } from '@tanstack/vue-query'
import { CkAlert } from '@ck/ui'
import { workOrdersApi } from '@ck/api-client'
import FilaVeiculos from '../components/FilaVeiculos.vue'

const route = useRoute()
const q = computed(() => typeof route.query.q === 'string' ? route.query.q : '')
const ordersQuery = useQuery(computed(() => ({ queryKey: ['work-orders', q.value], queryFn: () => workOrdersApi.list(q.value) })))
const orders = computed(() => ordersQuery.data.value?.items ?? [])
</script>

<template>
  <div>
    <div class="page-head"><h1>Ordens de serviço</h1><p>Acompanhamento de OS</p></div>
    <CkAlert v-if="ordersQuery.isError.value" tone="error" class="alert">Não foi possível carregar as ordens de serviço.</CkAlert>
    <FilaVeiculos :work-orders="orders"/>
  </div>
</template>

<style scoped>
.page-head { margin-bottom: 20px; }
.page-head h1 { margin: 0; font-family: var(--font-display); font-size: 26px; font-weight: 800; }
.page-head p { margin: 4px 0 0; color: var(--color-text-faint); font-size: 13px; }
.alert { margin-bottom: 16px; }
</style>
